import { useQuery } from '@tanstack/react-query';

import { getProjectDetailsByRevisionDate } from '../api/projects.api';

export const PROJECT_BY_REVISION_DATE_QUERY_KEY_ROOT = 'project-by-revision-date';

interface UseProjectDetailsByRevisionDateParams {
  params: {
    projectId: number;
    revisionDate: Date;
  };
  enabled?: boolean;
}

/**
 * Hook to fetch full project state at a specific revision date.
 * Used in EditChange mode to load historical project data.
 * Returns the complete Project state (info + billing) at the given date.
 */
export const useProjectDetailsByRevisionDate = ({
  params,
  enabled = true,
}: UseProjectDetailsByRevisionDateParams) => {
  const { projectId, revisionDate } = params;

  return useQuery({
    queryKey: [PROJECT_BY_REVISION_DATE_QUERY_KEY_ROOT, projectId, revisionDate.toISOString()],
    queryFn: () => getProjectDetailsByRevisionDate(projectId, revisionDate),
    enabled,
    staleTime: Infinity, // Historical data never changes, cache forever
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes after unmount
  });
};
